'use strict';
module.exports = [
    '$sce', function ($sce) {

        return {
            restrict: 'A',
            scope: {
                onSubmit: '&',
            },
            require: '?ngModel', // get a hold of NgModelController

            link: function (scope, element, attrs, ngModel) {
                if (!ngModel) return; // do nothing if no ng-model
                // Specify how UI should be updated
                ngModel.$render = function () {
                    element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
                };

                // Listen for change events to enable binding
                element.on('blur keydown change', function (evt) {
                    scope.$evalAsync(read);
                    if (evt.which == 13 && !evt.shiftKey) {
                        element.html($sce.getTrustedHtml(''));
                        evt.stopPropagation();
                        evt.preventDefault();
                        scope.onSubmit();
                    }
                });

                function strip_tags(html) {
                    var tmp = window.document.createElement('div');
                    tmp.innerHTML = html;
                    return tmp.textContent || tmp.innerText || '';
                }

                read(); // initialize

                // Write data to the model
                function read() {
                    let html = element.html();
                    let oldHtml = html;
                    // When we clear the content editable the browser leaves a <br> behind
                    // If strip-br attribute is provided then we strip this out
                    if (attrs.stripBr && html == '<br>') {
                        html = '';
                    }

                    let content = strip_tags(html.replace(/<br[^>]*>?/g, '\n'));
                    if (content.length > 1000) {
                        html = content.substring(0, 1000).replace(/\n/, '<br>');
                    }

                    if (oldHtml !== html) {
                        element.html(html);
                    }
                    ngModel.$setViewValue(html);
                }
            }
        };
    }
];